import React from 'react';

// Helper function to parse bold/strikethrough markdown
const parseInlineFormatting = (text, keyPrefix = '') => {
  const parts = text.split(/(\*\*.*?\*\*|~~.*?~~)/g);
  return parts.map((part, idx) => {
    // Bold
    if (part.startsWith('**') && part.endsWith('**')) {
      return <strong key={`${keyPrefix}-bold-${idx}`} className="text-white font-semibold">{part.slice(2, -2)}</strong>;
    }
    // Strikethrough
    if (part.startsWith('~~') && part.endsWith('~~')) {
      return <span key={`${keyPrefix}-strike-${idx}`} className="line-through text-gray-400">{part.slice(2, -2)}</span>;
    }
    return part;
  });
};

// Render list items with formatting
const renderListItem = (item, idx, keyPrefix) => {
  const text = item.substring(2); // Remove "- " or "✅ " or "❌ "
  return (
    <span key={`${keyPrefix}-item-${idx}`} className="text-gray-300 leading-relaxed">
      {parseInlineFormatting(text, `${keyPrefix}-${idx}`)}
    </span>
  );
};

// Render regular paragraph
export const renderParagraph = (line, key) => {
  return (
    <p key={key} className="text-gray-300 leading-relaxed mb-4">
      {parseInlineFormatting(line, `para-${key}`)}
    </p>
  );
};

// Render headings
export const renderHeading = (line, level, key) => {
  const text = line.substring(level + 1); // Remove "# ", "## ", or "### "
  
  const classNames = {
    1: "text-3xl md:text-4xl font-bold text-white mb-6 mt-8",
    2: "text-2xl md:text-3xl font-bold text-white mb-4 mt-8",
    3: "text-xl md:text-2xl font-semibold text-white mb-3 mt-6"
  };

  const Tag = `h${level}`;
  return React.createElement(Tag, { key, className: classNames[level] }, text);
};

// Render unordered list
export const renderUnorderedList = (items, key) => {
  return (
    <ul key={key} className="list-disc list-inside space-y-2 text-gray-300 mb-4 ml-4">
      {items.map((item, idx) => (
        <li key={`ul-${key}-${idx}`} className="leading-relaxed">
          {renderListItem(item, idx, `ul-${key}`)}
        </li>
      ))}
    </ul>
  );
};

// Render checkmark list
export const renderCheckmarkList = (items, key) => {
  return (
    <ul key={key} className="space-y-2 mb-4">
      {items.map((item, idx) => (
        <li key={`check-${key}-${idx}`} className="flex items-start space-x-2">
          <span className="text-green-400 mt-1">✅</span>
          {renderListItem(item, idx, `check-${key}`)}
        </li>
      ))}
    </ul>
  );
};

// Render cross mark item
export const renderCrossMarkItem = (line, key) => {
  const text = line.substring(2);
  return (
    <p key={key} className="flex items-start space-x-2 mb-2">
      <span className="text-red-400 mt-1">❌</span>
      <span className="text-gray-300 leading-relaxed">
        {parseInlineFormatting(text, `cross-${key}`)}
      </span>
    </p>
  );
};

// Render horizontal rule
export const renderHorizontalRule = (key) => {
  return <hr key={key} className="border-white/20 my-8" />;
};
